import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from 'components/Icon';
import { getConfigNetworkLogoUrl } from 'helpers/ContentHelper';
import { onEnterKeyPress } from 'helpers/Account';
import { isFoxSoulResetPasswordPage, isResetPage } from 'helpers/RouteHelper';
import Style from './AccountHeader.module.scss';

const Header = ({
  iconMobile,
  isDesktop,
  isGoogle,
  hideCloseButton,
  onClose,
  noIcon,
  renderLogo,
}) => {
  let closeButtonClass = Style.close;

  const handleClose = () => onClose({ goHome: true });
  const isMobile = !isDesktop && iconMobile ? iconMobile : renderLogo(handleClose);
  const icon = noIcon || (!isDesktop && isGoogle) ? null : isMobile;
  const networkLogo = isFoxSoulResetPasswordPage ? (
    <img className={Style.logo} src={getConfigNetworkLogoUrl('SOUL')} alt="Fox Soul" />
  ) : (
    <img className={Style.logo} src={getConfigNetworkLogoUrl('fox')} alt="Fox" />
  );

  if (hideCloseButton) closeButtonClass = classNames(closeButtonClass, Style.closeHidden);
  return (
    <div
      className={classNames(
        Style.AccountHeader,
        isResetPage && Style.OnlyLogoHeader,
        isFoxSoulResetPasswordPage && Style.isFoxSoul,
      )}
    >
      {isResetPage ? (
        networkLogo
      ) : (
        <div className={Style.InnerHeaderWrap}>
          <div className={classNames(Style.header, !isDesktop && isGoogle && Style.isGoogle)}>
            {icon}
            <button
              onClick={onClose}
              onKeyPress={e => {
                onEnterKeyPress(e, onClose);
              }}
              tabIndex="0"
              aria-label="close account dialog"
              className={closeButtonClass}
            >
              <Icon icon="close" color="white" size="full" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

Header.defaultProps = {
  iconMobile: null,
  isDesktop: false,
  hideCloseButton: false,
  noIcon: false,
  renderLogo: () => {},
  onClose: () => {},
};

Header.propTypes = {
  hideCloseButton: PropTypes.bool,
  iconMobile: PropTypes.shape({}),
  isDesktop: PropTypes.bool,
  isGoogle: PropTypes.bool,
  noIcon: PropTypes.bool,
  onClose: PropTypes.func,
  renderLogo: PropTypes.func,
};

export default Header;
